import { WORDPRESS_API } from "shared/constants/api";


export const teacherDocumentGroups = [
  {
    id: "organization",
    title: "Organizacja pracy szkoły",
    documents: [
      {
        id: "kontrola-obowiazku-nauki",
        title: "Kontrola realizacji obowiązku nauki",
        href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Kontrola-realizacji-obowiązku-nauki.pdf`
      },
      {
        id: "dyzury-srodlekcyjne",
        title: "Regulamin pełnienia dyżurów śródlekcyjnych",
        href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Regulamin-pełnienia-dyżurów-śródlekcyjnych.pdf`
      },
      {
        id: "rozklad-lekcji",
        title: "Rozkład lekcji i przerw międzylekcyjnych",
        href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Rozkład-lekcji-i-przerw-międzylekcyjnych.pdf`
      },
      {
        id: "opuszczanie-terenu-szkoly",
        title: "Zasady opuszczania przez uczniów terenu szkoły podczas zajęć",
        href: `${WORDPRESS_API}/wp-content/uploads/2019/04/Zasady-opuszczania-przez-uczniów-terenu-szkoły-podczas-zajęć.pdf`
      }
    ]
  },
  {
    id: "students",
    title: "Uczniowie i ocenianie",
    documents: [
      {
        id: "procedura-ocena-zachowania",
        title: "Procedura wystawiania oceny zachowania",
        href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Procedura-wystawiania-oceny-zachowania.pdf`
      },
      {
        id: "szczesliwy-numerek",
        title: "Regulamin „Szczęśliwy numerek”",
        href: `${WORDPRESS_API}/wp-content/uploads/2019/04/Regulamin-Szczęśliwy-numerek.pdf`
      },
      {
        id: "sc227",
        title: "Regulamin przyznawania nagród uczniom",
        href: `${WORDPRESS_API}/wp-content/uploads/2019/03/SC227-CKZIU24061907280.pdf`
      },
      {
        id: "skreslenie-z-listy",
        title: "Skreślenie z listy uczniów",
        href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Skreślenie-z-listy-uczniów.pdf`
      },
      {
        id: "zwolnienie-wf",
        title: "Wniosek o zwolnienie z wychowania fizycznego",
        href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Wniosek-zwolnienie-w-f.pdf`
      },
      {
        id: "zwolnienie-drugi-jezyk",
        title: "Zwolnienie z nauki drugiego języka obcego nowożytnego",
        href: `${WORDPRESS_API}/wp-content/uploads/2019/04/Zwolnienie_z_nauki_drugiego_języka_obcego_nowożytnego.pdf`
      }
    ]
  },
  {
    id: "regulations",
    title: "Regulaminy i procedury",
    documents: [
      {
        id: "konkursy-i-zawody",
        title: "Regulamin przeprowadzania konkursów i zawodów",
        href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Regulamin-przeprowadzania-konkursów-i-zawodów.pdf`
      },
      {
        id: "studniowka",
        title: "Regulamin studniówki",
        href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Regulamin-studniówki.pdf`
      },
      {
        id: "praktyczna-nauka-zawodu",
        title: "Regulamin praktycznej nauki zawodu",
        href: `${WORDPRESS_API}/wp-content/uploads/2019/04/Regulamin_praktycznej_nauki_zawodu.pdf`
      },
      {
        id: "skargi-i-wnioski",
        title: "Rozpatrywanie skarg i wniosków",
        href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Rozpatrywanie-skarg-i-wniosków.pdf`
      }
    ]
  },
  {
    id: "support",
    title: "Pomoc i bezpieczeństwo",
    documents: [
      {
        id: "pomoc-psychologiczno-pedagogiczna",
        title: "Pomoc psychologiczno-pedagogiczna",
        href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Pomoc-psychologiczno-pedagogiczna-1.pdf`
      },
      {
        id: "zagrozenie-terrorystyczne",
        title: "Instrukcja postępowania w przypadku zagrożenia atakiem terrorystycznym",
        href: `${WORDPRESS_API}/wp-content/uploads/2019/03/Instrukcja_postępowania_w_przypadku_zagrożenia%20atakiem_terrorystycznym.pdf`
      }
    ]
  }
];